import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

export default function HeatmapLegend({ type, maxCount, colors, label }) {
  const gradient = `linear-gradient(to top, ${colors.join(', ')})`;

  return (
    <Stack direction="row" spacing={1} alignItems="stretch" height="300px">
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography 
          variant="caption" 
          sx={{ 
            writingMode: 'vertical-rl', 
            transform: 'rotate(180deg)',
            whiteSpace: 'nowrap',
            color: 'text.secondary'
          }}
        >
          {label}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="caption">{maxCount}</Typography>
        <Box 
          sx={{ 
            flex: 1, 
            width: '15px', 
            background: gradient, 
            borderRadius: '10px',
            my: 1
          }}
        />
        <Typography variant="caption">0</Typography>
      </Box>
    </Stack>
  );
}